import HiddenJupyterIframe from './HiddenJupyterIframe';

export default HiddenJupyterIframe;
